(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Livechat2Sdk", [], factory);
	else if(typeof exports === 'object')
		exports["Livechat2Sdk"] = factory();
	else
		root["Livechat2Sdk"] = factory();
})(self, function() {
return 